import React from "react";

import Manage from "./Manage";
import Members from "./Members";
import ScoreCredits from "./ScoreCredits";

export interface ISubscriptionManagementProps {}

export default class SubscriptionManagement extends React.PureComponent<ISubscriptionManagementProps> {
  render() {
    return (
      <div className="SubscriptionManagement">
        <Manage />
        <Members />
        <ScoreCredits />
      </div>
    );
  }
}
